export const ConstraintTypes = Object.freeze({
  INTERNSHIPS_BLOCKING: 'INTERNSHIPS_BLOCKING'
})

export class ConstraintType {
  constructor({ id = 1, type = ConstraintTypes.INTERNSHIPS_BLOCKING } = {}) {
    this.id = id
    this.type = type
  }
}